/**
 * @flow
 * @relayHash cd6173f5ecc1753156e3dd50a8ce7b47
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CustomerCategoryUpdateInput = {|
  id: string,
  name: string,
|};
export type UpdateCustomerCategoryMutationVariables = {|
  data: CustomerCategoryUpdateInput
|};
export type UpdateCustomerCategoryMutationResponse = {|
  +updateCustomerCategory: {|
    +id: string
  |}
|};
export type UpdateCustomerCategoryMutation = {|
  variables: UpdateCustomerCategoryMutationVariables,
  response: UpdateCustomerCategoryMutationResponse,
|};
*/


/*
mutation UpdateCustomerCategoryMutation(
  $data: CustomerCategoryUpdateInput!
) {
  updateCustomerCategory(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CustomerCategoryUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCustomerCategory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CustomerCategoryModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCustomerCategoryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCustomerCategoryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCustomerCategoryMutation",
    "id": null,
    "text": "mutation UpdateCustomerCategoryMutation(\n  $data: CustomerCategoryUpdateInput!\n) {\n  updateCustomerCategory(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2860bbcdd3b68e86c52498c7c8a17f1f';
module.exports = node;
